import React from 'react';

import RootLayout from './src/components/Layout/Root';

export const wrapRootElement = ({ element }) => <RootLayout>{element}</RootLayout>;
